


















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
  inheritAttrs: false,
})
export default class StSearch extends Vue {
  @Prop() value!: any;
  @Prop() inputClass!: string;
  @Prop() focus!: boolean;
  @Prop() displayLoading!: boolean;

  mounted() {
    if (this.focus) (this.$refs.inputfield as HTMLInputElement).focus();
  }

  @Emit('input')
  input(event: any) {
    return event.currentTarget.value;
  }
}
